import { render } from "./PanelsDemo.vue?vue&type=template&id=1c329cb6"
import script from "./PanelsDemo.vue?vue&type=script&lang=js"
export * from "./PanelsDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/chatbot_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__